export enum ContractorStepDetailsCardStatus {
  NotStarted = 'not_started',
  InProgress = 'in_progress',
  WaitingForApproval = 'waiting_for_approval',
  Pending = 'pending',
  Approved = 'approved',
  Failed = 'failed',
  Declined = 'declined',
  Expired = 'expired',
  ExpiringSoon = 'expiring_soon',
  Recollect = 'recollect',
  AbortRecollection = 'abort_recollection',
}

export enum ContractorStepDetailsCardVariant {
  Default = 'default',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export enum ContractorStepDetailsCardUsageVariant {
  Contractor = 'contractor',
  MasterContractor = 'masterContractor',
}

export type CardStatusType = 'Valid' | 'Delayed' | 'NotValid'
